import axios from "axios";
import { AuditShowResponse } from "../types";
import type { Window as WindowType } from "@/types/window";

const store = (window as WindowType).store;

const client = axios.create({
  baseURL: "https://audit.2kbo.com:7101/api/v1/audit",
});

const MAX_BATCH_SIZE = 50;
const MAX_STORED_QUEUE_SIZE = 500;
const FLUSH_INTERVAL = 5000;

let interval: ReturnType<typeof setTimeout>;
const queue = getStoredQueue();

function start() {
  flushQueue();
  interval = setInterval(flushQueue, FLUSH_INTERVAL);
}

function updateStoredQueue() {
  window.localStorage.setItem("auditQueue", JSON.stringify(queue));
}

function getStoredQueue() {
  const storedQueue = window.localStorage.getItem("auditQueue");
  if (storedQueue) {
    return JSON.parse(storedQueue);
  }
  return [];
}

async function flushQueue() {
  const batches = queue.splice(0, queue.length);
  if (batches.length > 0) {
    try {
      await client.post("/batch", batches);
      updateStoredQueue();
    } catch (error) {
      console.warn("Error flushing audit queue:", error);
      if (queue.length < MAX_STORED_QUEUE_SIZE) {
        console.warn("Adding audit batches back to queue", batches);
        queue.push(...batches);
        updateStoredQueue();
      }
    }
  }
}

setTimeout(() => {
  start();
}, 1000);

type AuditData = Record<string, unknown>;

export const addToQueue = (
  resource: string,
  action: string,
  resourceId: number,
  wg: number,
  central: number,
  data: AuditData
) => {
  if (!resource || !action || !wg) {
    console.error(`Invalid audit data ${resource}:${action} wg:${wg} central:${central}`, data);
    return;
  }
  const operator = store.getters["operators/operator"];
  queue.push({
    wg,
    central,
    resource,
    resourceId,
    events: [
      {
        action,
        opId: operator.id,
        opName: operator.name,
        data,
        timestamp: Date.now(),
      },
    ],
  });

  if (queue.length > MAX_BATCH_SIZE) {
    flushQueue();
  }

  updateStoredQueue();
};

export async function get(wg: number, central: number, resource: string, id: number) {
  const response = await client.get<AuditShowResponse>(`/show/${wg}/${central}/${resource}/${id}`);
  return response.data;
}

export default {
  addToQueue,
};
